module.exports = __webpack_public_path__ + "static/media/coo.a93b95f0.png";